import { render, staticRenderFns } from "./NewTable.vue?vue&type=template&id=31922e4c&"
import script from "./NewTable.vue?vue&type=script&lang=js&"
export * from "./NewTable.vue?vue&type=script&lang=js&"
import style0 from "./NewTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports